import { useEffect, useRef, useState } from "react";

export function useInfiniteList<T extends HTMLElement = HTMLElement>(
  total: number,
  resetKey: string,
  step = 40
) {
  const [count, setCount] = useState(step);
  const sentinelRef = useRef<T>(null);

  const [prevResetKey, setPrevResetKey] = useState(resetKey);
  if (prevResetKey !== resetKey) {
    setPrevResetKey(resetKey);
    setCount(step);
  }

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el || count >= total) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setCount((c) => Math.min(c + step, total));
        }
      },
      { rootMargin: "300px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [count, total, step]);

  return { count, sentinelRef, hasMore: count < total };
}
